/**
 * Mount-once shim that keeps a single WebSocket open to the Quickback
 * broadcast service and dispatches incoming events to the QueryClient cache.
 * Renders nothing — it's a side-effect-only component so a single hook
 * instance survives route transitions.
 *
 * Mounted inside the `<App />` shell so it spans the whole authenticated UI.
 */
import { useRealtime } from "../lib/realtime";

export default function RealtimeBridge(): null {
    useRealtime();
    return null;
}
